import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../hooks/redux/base/useAppDispatch";
import * as yup from "yup";
import {
  BoxSpg,
  GridItem,
  InputFormField,
  MediumButton,
  MediumGreyButton,
  NomenclatureAutocompleteFilter,
  useReactHookForm,
} from "@duosoftbg/nacid-components";

import { FormProvider } from "react-hook-form";
import { Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import {
  educationSystemsFilterInitialData,
  overrideFiltersData,
} from "../../../store/redux/slice/SearchData/educationSystemsSearchData";
import { countryRegionsThunk } from "../../../store/redux/slice/AppData/countryRegions";

const EducationSystemsOverviewSearchForm = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const validationSchema = () => {
    return yup.object().shape({});
  };

  const { methods, handleSubmit } = useReactHookForm({
    defaultValues: educationSystemsFilterInitialData,
    validationSchema,
  });

  const onSubmit = (values) => {
    dispatch(overrideFiltersData(values));
  };

  const resetForm = () => {
    methods.reset();
    dispatch(overrideFiltersData(educationSystemsFilterInitialData));
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={5}>
          <Grid item sm={12} md={12} lg={10}>
            <Grid container spacing={5}>
              <Grid item xs={6} mt={3}>
                <InputFormField fieldName="name" labelCode="l.countryName" />
              </Grid>
              <Grid item xs={6}>
                <CountryRegionField />
              </Grid>
            </Grid>
          </Grid>
          <GridItem sm={12} md={12} lg={12}>
            <BoxSpg sx={{ display: "flex", justifyContent: "end" }}>
              <MediumButton
                startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faSearch} />}
                size={"small"}
                type={"submit"}
                variant="contained"
                color="primary"
              >
                {t("l.btn.search")}
              </MediumButton>
              <MediumGreyButton
                size={"small"}
                startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faClose} />}
                onClick={resetForm}
                style={{ marginLeft: "15px" }}
                variant="contained"
              >
                {t("l.btn.clear")}
              </MediumGreyButton>
            </BoxSpg>
          </GridItem>
        </Grid>
      </form>
    </FormProvider>
  );
};

const CountryRegionField = () => {
  const thunkState = useAppSelector((state) => {
    return state.AppData.countryRegions;
  });

  const getPreviousStateOptionFn = () => "";

  return (
    <NomenclatureAutocompleteFilter
      filter={"regionId"}
      label="l.region"
      thunkFn={countryRegionsThunk}
      thunkState={thunkState}
      getPreviousStateOptionFn={getPreviousStateOptionFn}
      xs={12}
      sm={12}
      md={12}
    />
  );
};

export default EducationSystemsOverviewSearchForm;
